import React, { useEffect, useRef, useState } from "react";
import { imageBaseURL } from "../../../../constants/utils";
import { useDispatch, useSelector } from "react-redux";
import useToaster from "../../../../customHook/useToaster";
import {
  caseDescriptionPut,
  getAllCasesSegmentInfo,
} from "../../../../Services/caseManagement.service";
import style from "./CaseDescription.module.css";
import MuiTab from "../../../../CommonComponents/Tab/MuiTab";
import { tabs2CaseManagement } from "../../../../constants/caseManagementData";
import CommonDescription from "../../../../CommonComponents/CommonDescription";
import CaseDescriptionBox from "./CaseDescriptionBox";
import useApiCancellation from "../../../../customHook/useApiCancellation";
import { useLocation, useNavigate } from "react-router";
import { caseManagementMenuReducer } from "../../../../Redux/Slice/CaseManagementMenuSlice";

const CaseDescription = ({ onSubmit = () => {}, isFrom = null }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [tabValue, setTabValue] = useState("Basic");
  const [descriptions, setDescriptions] = useState([]);
  const [newDescription, setNewDescription] = useState({});
  const [reRender, setReRender] = useState(false);
  const descriptionRef = useRef();
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const { cancelRequest, createNewController } = useApiCancellation();
  const { showToast } = useToaster();
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const onBackClick = () => {
    if (state?.redirectTo) {
      if (state?.redirectTo === "/caseSearchView") {
        return navigate(-1);
      }
      dispatch(
        caseManagementMenuReducer({
          caseManagementMenuTab: state?.tabName,
          caseManagementMenuTabIndex: state?.tabIndex,
        })
      );
      navigate(state?.redirectTo, {
        state: { ...state, redirectTo: "" },
      });
    }
  };
  const tabClickHandler = (e, newValue) => {
    setActiveTab(newValue);
    setTabValue(e.target?.innerText?.split(" ")[0]);
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const inputChangeHandler = (e) => {
    setNewDescription((prev) => {
      return { ...prev, [tabValue]: e.target.value };
    });
  };
  const submitHandler = async () => {
    try {
      setReRender(true);
      const data = await caseDescriptionPut(
        capitalizeFirstLetter(tabValue) === "CHASE"
          ? "External"
          : capitalizeFirstLetter(tabValue),
        {
          caseId: caseId,
          description: newDescription[tabValue],
        }
      );
      if (descriptionRef.current) {
        descriptionRef.current.value = "";
      }
      if (data?.success) {
        showToast(data?.message, "success", true);
        onSubmit(true);
        setNewDescription((prev) => {
          return { ...prev, [tabValue]: "" };
        });
      }
    } catch (error) {
      showToast("Error in updating description", "error", true);
    }
  };

  useEffect(() => {
    cancelRequest(); // Cancel any ongoing request before making a new one
    const controller = createNewController(); // Create a new controller
    getAllCasesSegmentInfo(
      tabValue === "CHASE" ? "External" : tabValue,
      { caseId },
      controller.signal
    )
      .then((response) => {
        setReRender(false);
        if (response?.success) {
          showToast(response?.message, "success", true);
          const desc = Array.isArray(response?.data)
            ? (response?.data?.[0]?.case_description ?? [])
            : (response?.data?.case_description ?? []);

          setDescriptions(desc);
        }
      })
      .catch((error) => {
        setReRender(false);
        showToast("Error while fetching case descriptions", "error", true);
      });
  }, [caseId, tabValue, activeTab, reRender]);

  useEffect(() => {
    setNewDescription((prev) => {
      return {
        ...prev,
        [tabValue]: "",
      };
    });
  }, [activeTab, tabValue]);

  return (
    <div className={style["cd-main-container"]}>
      <div className={style["cd-navigation"]}>
        <img
          className={style["backArrow_Image"]}
          src={`${imageBaseURL}/Svg/backArrowBold.svg`}
          alt="backArrow"
          loading="lazy"
          onClick={onBackClick}
        />
        <h1 className={style["assign_block_header"]}>Case Description</h1>
      </div>
      <div className={style["cd-contents"]}>
        <div className={style["cd-tabs"]}>
          <MuiTab
            tabs={tabs2CaseManagement}
            activeTab={activeTab}
            onClick={tabClickHandler}
            variant="customStyleTab"
            customStyle={{
              borderRadius: "4px",
              padding: "12px 16px !important",
              fontSize: "11px",
              height: "40px",
              lineHeight: 1,
              border: "1px solid #E2E2E2",
              gap: "2px",
              marginRight: "13px",
              marginLeft: "4px",
              textTransform: "none",
            }}
            customTabSelectStyle={{
              boxShadow: "0px 2px 7px 0px #0000004D",
              backgroundColor: "white",
              fontWeight: 600,
            }}
          />
        </div>
        <CaseDescriptionBox
          data={descriptions}
          styles={{ boxShadow: "0px 2px 4px 4px #A39D9933" }}
        />
        <CommonDescription
          isTabView={false}
          minRows={6}
          heading={
            <p
              style={{
                fontWeight: "600",
                color: "black",
                fontSize: "1.3rem",
                padding: "1rem 0rem",
              }}
            >
              Your Comment
            </p>
          }
          placeholder=" Write here..."
          onChange={inputChangeHandler}
          onSubmitButton={submitHandler}
          bgcolor={"#FAFAFA"}
          isSubmitActive={newDescription[tabValue]?.length > 0 ? true : false}
          // descriptionRef={descriptionRef}
          descriptionVal={newDescription[tabValue] || ""}
        />
      </div>
    </div>
  );
};

export default CaseDescription;
